import axios from 'axios';
import { env } from '../../config/env';

const VERIFY_URL  = 'https://usc1.verify.microblink.com/api/v2/docver';
const LOGS_URL    = 'https://api.devdicio.net:8444/v1/sec_dev_noco_microblink_verify';
const VERIFY_AUTH = 'ODNhODE1M2EtNjg1MC00ZDNlLWE3N2EtN2EyYWQwZTdkNzA0OipAZW9IRjVAd2lYU0hodF5qR0Io';

export interface VerifyOptions {
  frontImage: string;
  backImage:  string;
  options?:   Record<string, unknown>;
}

export interface VerifyResult {
  verification?: {
    certaintyLevel:  string;
    type:            string;
    result:          string;
    performedChecks: string;
  };
}

/** Llama al endpoint de verificación de Microblink Verify. */
export async function verifyDocument({ frontImage, backImage, options = {} }: VerifyOptions) {
  // Microblink Verify requiere headers limpios
  const instance = axios.create();
  const { data } = await instance.post<VerifyResult>(
    VERIFY_URL,
    { imageFront: { base64: frontImage }, imageBack: { base64: backImage }, options },
    { headers: { Authorization: `Basic ${VERIFY_AUTH}`, 'Content-Type': 'application/json' } },
  );
  return data;
}

export interface SaveVerifyLogPayload {
  uuid:            string;
  responseGotten:  string;
  verifyResponse:  unknown;
  frontImage:      string;
  backImage:       string;
}

/** Guarda el log de verificación en NocoDB. */
export async function saveVerifyLog({
  uuid, responseGotten, verifyResponse, frontImage, backImage,
}: SaveVerifyLogPayload): Promise<void> {
  await axios.post(
    LOGS_URL,
    {
      uuid,
      tipo_id:             sessionStorage.getItem('idType')           ?? 'Sin información',
      respuesta_esperada:  sessionStorage.getItem('expectedResponse') ?? 'Sin información',
      respuesta_obtenida:  responseGotten,
      dispositivo:         navigator.userAgent,
      time_stamp:          new Date().toISOString(),
      tipo_muestra:        sessionStorage.getItem('sampleType')       ?? 'Sin información',
      json_verify:         JSON.stringify(verifyResponse),
      image_front:         JSON.stringify(frontImage),
      image_back:          JSON.stringify(backImage),
    },
    {
      headers: {
        accept:       'application/json',
        'xc-auth':    env.nocoToken,
        'Content-Type': 'application/json',
      },
    },
  );
}
